// extracted by css-extract-rspack-plugin
export default {"wrapper":"StepsWrapper_wrapper__PD9bF","columnDirection":"StepsWrapper_columnDirection__d3h9S"};